import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser, selectUser } from '../../redux/slices/authSlice';
import { loadCounts, selectCounts } from '../../redux/slices/underwriterSlice';
import './index.scss';

const initialsOf = (name = '') =>
  name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0].toUpperCase())
    .join('');

const ROLE_LABEL = {
  UNDERWRITER: 'Underwriter',
  REVIEWER: 'Reviewer',
  ADMIN: 'Administrator'
};

const UnderwriterLayout = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const counts = useSelector(selectCounts);

  useEffect(() => {
    dispatch(loadCounts());
  }, [dispatch]);

  const pending = counts.submitted + counts.underReview + counts.moreInfo;

  return (
    <div className="uw-shell">
      <header className="uw-header">
        <div className="uw-header__brand">
          <span className="uw-header__mark">CreditFlow</span>
          <span className="uw-header__role">{ROLE_LABEL[user?.role] ?? 'Internal'}</span>
        </div>

        <div className="uw-header__right">
          {pending > 0 && (
            <span className="uw-header__pending">
              <span className="uw-header__pending-dot" />
              {pending} awaiting review
            </span>
          )}

          <div className="uw-header__user">
            <span className="uw-header__avatar" aria-hidden="true">
              {initialsOf(user?.username)}
            </span>
            <span className="uw-header__user-meta">
              <span className="uw-header__user-name">{user?.username}</span>
              <span className="uw-header__user-sub">{ROLE_LABEL[user?.role]}</span>
            </span>
          </div>

          <button
            type="button"
            className="uw-header__signout"
            onClick={() => dispatch(logoutUser())}>
            Sign out
          </button>
        </div>
      </header>

      <div className="uw-stats">
        <div className="uw-stat">
          <span className="uw-stat__value numeric">{counts.submitted}</span>
          <span className="uw-stat__label">In queue</span>
        </div>
        <div className="uw-stat uw-stat--review">
          <span className="uw-stat__value numeric">{counts.underReview}</span>
          <span className="uw-stat__label">Under review</span>
        </div>
        <div className="uw-stat uw-stat--pending">
          <span className="uw-stat__value numeric">{counts.moreInfo}</span>
          <span className="uw-stat__label">Awaiting applicant</span>
        </div>
        <div className="uw-stat uw-stat--approved">
          <span className="uw-stat__value numeric">{counts.approved}</span>
          <span className="uw-stat__label">Approved</span>
        </div>
        <div className="uw-stat uw-stat--declined">
          <span className="uw-stat__value numeric">{counts.rejected}</span>
          <span className="uw-stat__label">Declined</span>
        </div>
      </div>

      <main className="uw-body">
        <Outlet />
      </main>
    </div>
  );
};

export default UnderwriterLayout;
